import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
import { homeFaqs } from '../data/faq';
export const FAQ: React.FC = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section id="faq" className="w-full bg-white py-20 md:py-24 scroll-mt-24" data-id="element-320" data-mp="1ccneody0lu0f">
      <div className="container mx-auto px-4 md:px-6 lg:px-8 max-w-[900px]" data-id="element-321" data-mp="2a1gz0ard5863">
        <div className="mb-12" data-id="element-322" data-mp="254gtq22c89g1">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          ease: [0.23, 1, 0.32, 1]
        }} className="font-bold text-[#111827] mb-4 text-3xl md:text-4xl" data-id="element-323" data-mp="251b4mmtpl7kb">
            Veelgestelde vragen over online gevonden worden
          </motion.h2>
          <p className="text-[#6B7280] text-lg leading-relaxed" data-id="element-324" data-mp="1knzy6boe06tv">
            De vragen die ondernemers ons in het eerste gesprek stellen. Staat
            jouw vraag er niet bij, bel dan gewoon.
          </p>
        </div>
        <dl className="space-y-4" data-id="element-325" data-mp="1aqc13f3b6n8j">
          {homeFaqs.map((faq, index) => <motion.div key={faq.question} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.35,
          delay: Math.min(index, 4) * 0.05,
          ease: [0.23, 1, 0.32, 1]
        }} className="bg-[#F7F8FA] rounded-xl overflow-hidden" data-id="element-326" data-mp="1fonc3t5cb3sc" data-mpi={index}>
              <dt data-id="element-327" data-mp="rx86nri9o6cv">
                <button onClick={() => toggleFAQ(index)} aria-expanded={openIndex === index} aria-controls={`faq-antwoord-${index}`} className="w-full flex items-center justify-between p-6 text-left hover:bg-gray-100 transition-colors duration-200" data-id="element-328" data-mp="wxw5gzcqlrhn">
                  <span className="font-semibold text-[#111827] pr-8" data-id="element-329" data-mp="mzgbmombs44g">
                    {faq.question}
                  </span>
                  <motion.span animate={{
                rotate: openIndex === index ? 180 : 0
              }} transition={{
                duration: 0.2,
                ease: [0.23, 1, 0.32, 1]
              }} className="flex-shrink-0" data-id="element-330" data-mp="2kvwz2i88jr4x">
                    <ChevronDownIcon className="h-5 w-5 text-[#004AC7]" aria-hidden="true" data-id="element-331" data-mp="2ays907b9rbiu" />
                  </motion.span>
                </button>
              </dt>
              <AnimatePresence initial={false} data-id="element-332" data-mp="33mo457l6wvdi">
                {openIndex === index && <motion.dd id={`faq-antwoord-${index}`} initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.25,
              ease: [0.23, 1, 0.32, 1]
            }} className="overflow-hidden" data-id="element-333" data-mp="33kbmkvjcgn0z">
                    <div className="px-6 pb-6 text-[#6B7280] leading-relaxed border-t border-gray-200/60 pt-4" data-id="element-334" data-mp="3utwr0jfnafbo">
                      {faq.answer}
                    </div>
                  </motion.dd>}
              </AnimatePresence>
            </motion.div>)}
        </dl>
      </div>
    </section>;
};